import React, { useState, useEffect } from 'react';
import { Modal, Button} from 'antd';
import { EditOutlined } from '@ant-design/icons'
import { FileUpload } from '@/components'; // Assuming path

export const DirectUploadButton = ({ onSave, maxCount = 5, buttonText = "Edit", ogFileList }) => {
    // console.log('ogFileList:', ogFileList);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fileList, setFileList] = useState(Array.isArray(ogFileList) ? ogFileList : []);

    useEffect(() => {
        // This logic runs only when the modal is opened.
        if (isModalOpen) {
            // 1. Start with the incoming array of URL strings.
            const initialUrls = Array.isArray(ogFileList) ? ogFileList : [];
            
            // 2. Transform the array of URLs into the object format that antd's <Upload> expects.
            const initialFileList = initialUrls.map((url, index) => {
                // Get the full filename from the URL.
                let fullFilename = url.split('/').pop();
                
                // Truncate the timestamp to get the clean display name.
                const separatorIndex = fullFilename.indexOf('-');
                let displayName = (separatorIndex !== -1) 
                                  ? fullFilename.substring(separatorIndex + 1) 
                                  : fullFilename;

                return {
                    uid: `-${index + 1}`,   // A unique ID for React's list rendering
                    name: displayName,      // The clean, user-friendly name
                    status: 'done',         // Mark the file as already "uploaded"
                    url: url,               // The full, permanent URL for linking
                };
            });
            
            // 3. Set the state for the modal's FileUpload component.
            setFileList(initialFileList);
        }
    }, [isModalOpen, ogFileList]);
    const downloadFile = (file) => {
        // console.log('downloadFile', file);
        if (!file || !file.url) return;
        window.open(file.url, '_blank');
    };
    const handleOk = () => {
        // When the user clicks OK, pass the selected files up to the parent.
        onSave(fileList);
        setIsModalOpen(false);
    };

    return (
        <>
            {/* The button that the user sees and clicks */}
            <Button 
                type='link'
                style={{
                minWidth: '25px',
                textAlign: 'center',
                }}
                onClick={() => setIsModalOpen(true)}>
                <EditOutlined />
            </Button>

            {/* The modal that opens */}
            <Modal
                title="Modify Files"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={() => setIsModalOpen(false)}
                destroyOnClose={true}
            >
                <FileUpload
                    value={fileList}
                    onChange={setFileList}
                    maxCount={maxCount}
                    downloadFile={downloadFile}
                />
            </Modal>
        </>
    );
};